import React, { use } from "react";
import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const NftCard3 = ({ data, onClick = () => {}, isStaking }) => {
  const navigate = useNavigate();
  const image_hash = data?.image_hash;
  const imgSrc = `https://ipfs.io/ipfs/${image_hash}`;
  const isOnSale = data?.put_on_sale;

  return (
    <div className="card bg-black rounded-2xl p-3 cursor-pointer">
      <div className="relative flex flex-col justify-between h-full gap-4 justify-end">
        <div className="flex flex-col gap-4">
          <img
            src={imgSrc}
            className="w-full h-[8.375rem] rounded-xl object-cover"
            alt="not-found"
          />
          <h1 className="m-0 text-xl text-white font-normal leading-[1.5] line-clamp-2">
            {data?.name}
          </h1>
        </div>
        <div className="card-content rounded-lg bg-[#000000E5]">
          <div className="flex items-center justify-between">
            {isOnSale ? (
              <Button
                className="bg-yellowbuy border border-black rounded-lg text-base w-full h-8 font-bold text-black"
                onPress={() => navigate(`/item-details/${data?.address}`)}
              >
                On Sale
              </Button>
            ) : (
              <Button
                disabled={isStaking?.toString() === data?.token}
                isLoading={isStaking?.toString() === data?.token}
                className="bg-yellowbuy border border-black rounded-lg text-base w-full h-8 font-bold text-black"
                onPress={() => onClick(data?.token, data?.address)}
              >
                Stake
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftCard3;
